type ID = string

type BaseModel<T = unknown> = T & {
  id: ID
  created_at: string
  updated_at: string
}

enum BloodTypeEnum {
  A_PLUS = 'A+',
  A_MINUS = 'A-',
  B_PLUS = 'B+',
  B_MINUM = 'B-',
  AB_PLUS = 'AB+',
  AB_MINUS = 'AB-',
  O_PLUS = 'O+',
  O_MINUS = 'O-',
}

enum AgeUnitEnum {
  YEAR = 'YEAR',
  MONTH = 'MONTH',
}

enum GenderEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

enum MaritalStatusEnum {
  SINGLE = 'SINGLE',
  MARRIED = 'MARRIED',
  DIVORCED = 'DIVORCED',
  WIDOWED = 'WIDOWED',
}

enum MonthNameEnum {
  'JANUARY',
  'FEBRUARY',
  'MARCH',
  'APRIL',
  'MAY',
  'JUNE',
  'JULY',
  'AUGUST',
  'SEPTEMBER',
  'OCTOBER',
  'NOVEMBER',
  'DECEMBER',
}

enum RelationTypeEnum {
  MOTHER = 'MOTHER',
  FATHER = 'FATHER',
  MOTHER_IN_LAW = 'MOTHER_IN_LAW',
  FATHER_IN_LAW = 'FATHER_IN_LAW',
  BROTHER = 'BROTHER',
  SISTER = 'SISTER',
  WIFE = 'WIFE',
  HUSBAND = 'HUSBAND',
  SON = 'SON',
  DAUGHTER = 'DAUGHTER',
  GRAND_MOTHER = 'GRAND_MOTHER',
  GRAND_FATHER = 'GRAND_FATHER',
  GRAND_SON = 'GRAND_SON',
  GRAND_DAUGHTER = 'GRAND_DAUGHTER',
  UNCLE = 'UNCLE',
  AUNT = 'AUNT',
  NEPHEW = 'NEPHEW',
  NIECE = 'NIECE',
  COUSIN = 'COUSIN',
  FRIEND = 'FRIEND',
  OTHER = 'OTHER',
}

enum ReligionEnum {
  ISLAM = 'ISLAM',
  KRISTEN_PROTESTAN = 'KRISTEN_PROTESTAN',
  KATOLIK = 'KATOLIK',
  HINDU = 'HINDU',
  BUDDHA = 'BUDDHA',
  KONG_HU_CU = 'KONG_HU_CU',
}

enum DiscountTypeEnum {
  PERCENTAGE = 'PERCENTAGE',
  AMOUNT = 'AMOUNT',
}

export {
  DiscountTypeEnum,
  ReligionEnum,
  RelationTypeEnum,
  MonthNameEnum,
  MaritalStatusEnum,
  GenderEnum,
  AgeUnitEnum,
  BloodTypeEnum,
}

export type { BaseModel, ID }
